// extracted by mini-css-extract-plugin
export default {"clientStrip":"ClientStrip_clientStrip__WIMrL","logoTrack":"ClientStrip_logoTrack__dPZnP","scroll":"ClientStrip_scroll__snONi","clientLogo":"ClientStrip_clientLogo__Vqz51"};